<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <template v-if="device!=='mobile'">
        <!-- <search id="header-search" class="right-menu-item" /> -->

        <div  style="float: left;height: 100%;line-height: 50px;margin-right: 15px;">
        {{institution.name}}

    （ {{institution.level=='county'?'区县级':(institution.level=='city'?'市级':(institution.level=='province'?'省级':'街道'))}}

         {{institution.type=='hospital'?'医院':(institution.type=='school'?'学校':(institution.type=='nursery'?'幼儿园':'管理'))}}）
         {{nickname}}
         {{mobile}}
        </div>

        <div style="float: left;height: 100%;line-height: 50px;margin-right: 15px;">
            <el-select v-model="plan" @change="changePlan" filterable placeholder="请选择">
          <el-option v-for="item in planArr" :key="item.id" :label="item.plan_name" :value="item.id">
          </el-option>
        </el-select>
        </div>
        <div style="float: left;height: 100%;line-height: 50px;margin-right: 5px;">
          {{username}}
        </div>

        <error-log class="errLog-container right-menu-item hover-effect" />

        <el-tooltip content="全屏123" effect="dark" placement="bottom">
          <screenfull id="screenfull" class="right-menu-item hover-effect" />
        </el-tooltip>

        <!-- <el-tooltip content="字号" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip> -->

      </template>

      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <!-- <img :src="avatar==''?'https://static-e61560d4-668b-4bd7-ae4a-038c253253fc.bspapp.com/avatar.png':avatar+'?imageView2/1/w/80/h/80'" class="user-avatar"> -->
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <!-- <router-link to="/profile/indexNew">
            <el-dropdown-item>我的</el-dropdown-item>
          </router-link> -->
          <router-link :to="urlR">
            <el-dropdown-item>管理首页</el-dropdown-item>
          </router-link>

          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <a target="_blank" href="https://panjiachen.gitee.io/vue-element-admin-site/zh/">
        <el-dropdown-item>参考文档</el-dropdown-item>
      </a> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import Search from '@/components/HeaderSearch'
 import request from "../../utils/request";
export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    SizeSelect,
    Search
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device',
      'username','nickname',
      'mobile',
      'department',
      "userid",
      'plan_id',
      'institution',
      'roles'
    ])
  },
  data(){
    return{
      planArr:[],
      plan:0,
      urlR:''
    }
  },
  mounted(){
    this.plan=this.plan_id

    this.getPlanListAll()
    if(this.roles.length>0){
      for(const item of this.roles){
            if(item!=''){
              this.urlR=item
                break
            }
      }
    }else if(this.userid==1){
        this.urlR='/'
    }
  },
  methods: {
    changePlan(e){
      if(e>0){
          request({
            url: "admin/AdminUser/plan",
            method: "post",
            data: {
              admin_user_id: this.userid,
              plan_id: this.plan
            }
          })
          .then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              location.reload();
            }

          })
          .catch(err => {

          });
      }

    },
          getPlanListAll() {
            var age = 'all';
            if(this.institution.type=='manage'||this.institution.type=='hospital'){
              age = 'all'
            }
            if(this.institution.type=='nursery'){
              age = '06'
            }
            if(this.institution.type=='school'){
              age = '718'
            }
        request({
            url: "admin/ScreeningPlan/institutionList",
            method: "get",
            params: {
              page:1,
              limit:99999,
              age:age,
              dt:1
            },
          })
          .then((res) => {
            if (res.code == 200) {
              this.planArr = res.data;
              if(!this.plan_id){
                // console.log('go')
                this.plan = res.data[0].id
                this.changePlan(this.plan)
              }else{
                this.check_plan()
                
              }
            }
          })
          .catch((err) => {});
      },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      window.location.reload()
    },
    check_plan(){
        var i = 0;
        var oneid = this.planArr[0].id;
        this.planArr.forEach(e => {
			if(e.id == this.plan_id){
				i = 1;
			}
        });
        if(i == 0){
			request({
				url: "admin/ScreeningPlan/check_plan",
				method: "get",
				params: {
				id:oneid
				},
			})
          	.then((res) => {
				if (res.code == 200) {
					this.plan = oneid
					this.$store.dispatch("user/setPlanId", oneid).then((res) => {
						if (res == "ok") {
							// this.$message.success("操作成功");
						} else {
							// this.dialogVisible = false;
							// this.$message.error("操作失败");
						}
					});
				}
          	}).catch((err) => {});
        }
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    font-size: 15px;
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 13px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }
    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 30px;
          height: 30px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 15px;
          font-size: 13px;
        }
      }
    }
  }

}
</style>
